import React from 'react';

import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import cx from 'classnames';

import useStyles from './styles';

interface VideoAccordionProps {
  expanded?: boolean;
  onChange?: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
  children: NonNullable<React.ReactNode>;
}

const VideoAccordion: React.FC<VideoAccordionProps> = ({ children, expanded, onChange }) => {
  const classes = useStyles();
  return children ? (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      classes={{
        root: classes.accordionRoot,
        expanded: classes.accordionExpanded,
      }}
    >
      {children[0] && (
        <AccordionSummary
          classes={{
            root: classes.accordionSummary,
            expanded: classes.accordionSummaryExpanded,
            content: classes.accordionSummaryContent,
          }}
        >
          <div className={cx(classes.accordionIconBlock, expanded ? 'active' : '')} />
          {children[0]}
        </AccordionSummary>
      )}
      {children[1] && (
        <AccordionDetails
          classes={{
            root: classes.accordionDetails,
          }}
        >
          {children[1]}
        </AccordionDetails>
      )}
    </Accordion>
  ) : null;
};

export default VideoAccordion;
